export default __webpack_public_path__ + "static/media/pic3.b587580a.png";